module.exports = __webpack_public_path__ + "static/media/98.141b530c.jpg";